import { nanoid } from 'nanoid';

import { type CreateRawScanEventOptions, type RawScanEvent } from '../types/scanEvent.type';

export const createRawScanEvent = (
  barcodeValue: string,
  { createId = nanoid, now = Date.now }: CreateRawScanEventOptions = {},
): RawScanEvent => ({
  barcode_value: barcodeValue,
  correlation_id: createId(),
  detected_at: new Date(now()).toISOString(),
});
